import { importExport } from './import-export-en.i18n';

export const en = {
  importExport,
};
